'use client';

import Script from 'next/script';

import { isProduction } from '@/helpers/common';

export const HotjarPromoScript = () => {
  if (!isProduction()) {
    return null;
  }

  return <Script src="/pixels/hotjar-promo.js" strategy="afterInteractive" />;
};
